import { render, staticRenderFns } from "./parallel_diff_table_row.vue?vue&type=template&id=a1bfdcc6&"
import script from "./parallel_diff_table_row.vue?vue&type=script&lang=js&"
export * from "./parallel_diff_table_row.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports